import HttpCliente from "../servicios/HttpCliente";

export const saveClassificationAction = (classification) => HttpCliente.post("/classifications", classification);
export const getListClassification = () => HttpCliente.getOnly("/classifications");
export const deleteClassification = (id) => HttpCliente.delete('/classifications/delete/' + id);
export const updateClassification = (id, classification) => HttpCliente.put('/classifications/' + id, classification);
